<template>
  <div v-if="!isFloat" class="buy-tips">{{ $t('product.buyTips') }}</div>
  <div class="g-service">
    <div class="item">
      <div class="num">1</div>
      <span class="buyer">{{ $t('product.buyer') }}</span>
      <el-icon class="arrow">
        <ArrowRight />
      </el-icon>
      <span v-if="!isFloat" class="bold"> {{ $t('product.selfWarehouse') }}, </span>
      <span v-else class="bold"> {{ $t('product.warehouse') }}, </span>
      &nbsp;<span v-if="!isFloat">{{ $t('pecenter.package.freight') }}</span>
      <span v-else>{{ $t('pecenter.package.fee') }}</span>

      <el-input-number v-loading="$props.postageLoad" element-loading-custom-class="small-load" size="small"
        class="freight" :min="0" :max="10000" :precision="2" v-model="postage" @change="postageChange" />
      {{ userStore.currency }}
    </div>
    <div class="item">
      <div class="num">2</div>
      <span v-if="!isFloat" class="bold">
        {{ $t('product.selfWarehouse') }}
      </span>
      <el-icon v-if="!isFloat" class="arrow-2">
        <ArrowRight />
      </el-icon>
      <span v-if="!isFloat" class="address">{{ $t('product.yourAddress') }},</span>
      <span class="link" :style="{ paddingLeft: isFloat ? '0px' : '8px' }" @click="goEstimation">
        {{ $t('product.calcCountryFreight') }}</span>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores'
import { computed, defineEmits, defineProps } from 'vue'
const userStore = useUserStore()
const $props = defineProps({
  isFloat: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Number,
    default: 0.0,
  },
  max: {
    type: Number,
  },
  postageLoad: {
    type: Boolean,
    default: false,
  },
})
const $emit = defineEmits(['update:value', 'postageChange'])

const postage = computed({
  get() {
    return $props.value
  },
  set(value) {
    $emit('update:value', value)
  },
})
//前往估算运费
const goEstimation = () => {
  window.open('/estimation', '_blank')
}
// 邮费变更
const postageChange = () => {
  $emit('postageChange', postage.value)
}
</script>

<style lang="scss" scoped>
::v-deep {
  .small-load {

    // width: 10px;
    .el-loading-spinner {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateY(5px);
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.buy-tips {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  color: $gray-color;
  margin-bottom: 20px;
}

.g-service {
  background: var(--line-light-gray-color-1);
  padding: 23px 15px;
  margin-bottom: 22px;
  border-radius: 8px;

  .item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: var(--black-color-9);

    &:first-of-type {
      margin-bottom: 20px;
    }

    .bold {
      font-weight: bold;
      padding-right: 5px;
      white-space: nowrap;
    }

    .arrow {
      margin-right: 7px;
      margin-left: 7px;
    }

    .arrow-2 {
      margin: 0 5px;
    }

    .link {
      color: var(--primary-color);
      cursor: pointer;
      padding-left: 5px;
    }

    .freight {
      width: 64px;
      height: 32px;
      margin: 0 4px 0 6px;

      ::v-deep(.el-input__wrapper) {
        border-radius: 4px;
        background: var(--white-color-1);
        // border: 1px solid #dadee6;
        padding: 0;
        height: 32px;
      }

      ::v-deep(.el-input-number__increase),
      ::v-deep(.el-input-number__decrease) {
        display: none;
      }
    }

    .num {
      background-color: var(--primary-color);
      min-width: 20px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      font-family: Montserrat;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      text-transform: capitalize;
      letter-spacing: 0em;
      color: var(--white-color-1);
      text-align: center;
      margin-right: 15px;
    }
  }
}
</style>
